import AuthAPI from './authInstance'

const getAll = async (params = {}) => {
  const response = await AuthAPI.get(`/admin/user/list`, { params })
  return response.data
}

const getOne = async (data) => {
  const response = await AuthAPI.get(`/admin/user/show/${data}`)
  return response.data
}

export const customerService = {
  getAll,
  getOne,
}
